module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAAFiUAABYlAUlSJPAAAABjSURBVDhP7ZIxDsAgCEV7a6VR7DGJCb2AcWVxsDRx6UATlk596/tvgm06uQMRYebzFR2MMVZARCEEANgNVMUYW2srqLWmlBCxGKjSQe/9Eag4DFTlnP/gk8BxOPdruJ/PwZwXosMSLwtzEgsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/conversion-node.png
// module id = 979
// module chunks = 0